const USG = require('../../../../assets/icons/ultrasonic.png');
const RHEUMATOLOGY = require('../../../../assets/icons/rheumatology.png');
const SURGERY = require('../../../../assets/icons/surgery.png');
const PHYSICAL_THERAPY = require('../../../../assets/icons/physical-therapy.png');
// const PEDIATRICAN = require('../../../../assets/icons/pediatrician.png');
const BIOPSY = require('../../../../assets/icons/eye.png');
const NEUROLOGY = require('../../../../assets/icons/neurology.png');
const ENDOCRINOLOGY = require('../../../../assets/icons/endocrinology.png');
const featuresData = [
    {
        'icon': USG,
        'title': 'USG',
        'description': 'Nowoczesny sprzęt oraz precyzyjna diagnostyka ultrasonograficzna.'
    },
    {
        'icon': PHYSICAL_THERAPY,
        'title': 'REHABILITACJA MEDYCZNA',
        'description': 'Kompleksowa ocena i terapia schorzeń układu ruchu oraz bólu przewlekłego.'
    },
    {
        'icon': SURGERY,
        'title': 'CHIRURGIA',
        'description': 'Diagnostyka i leczenie chorób chirurgicznych, kwalifikacje do zabiegów, usuwanie zmian skórnych wraz z badaniem histopatologicznym.'
    },
    {
        'icon': RHEUMATOLOGY,
        'title': 'REUMATOLOGIA',
        'description': 'Diagnostyka i leczenie chorób reumatycznych, zwyrodnień stawów oraz schorzeń tkanki łącznej.'
    },
    // {
    //     'icon': PEDIATRICAN,
    //     'title': 'PEDIATRIA',
    //     'description': 'Pomoc medyczna w zakresie chorób, monitorowania rozwoju oraz profilaktyki zdrowotnej dla dzieci i młodzieży od urodzenia do ukończenia 18. roku życia.'
    // },
    {
        'icon': BIOPSY,
        'title': 'BIOPSJA CIENKOIGŁOWA',
        'description': 'Diagnostyka zmian ogniskowych tarczycy i patologicznych węzłów chłonnych.'
    },
    {
        'icon': NEUROLOGY,
        'title': 'NEUROLOGIA',
        'description': 'Diagnozowanie, leczenie i prewencja chorób ośrodkowego i obwodowego układu nerwowego.'
    },
    {
        'icon': ENDOCRINOLOGY,
        'title': 'ENDOKRYNOLOGIA',
        'description': 'Diagnostyka, leczenie oraz monitorowanie zaburzeń hormonalnych i chorób gruczołów dokrewnych m.in. tarczycy, przysadki, nadnerczy, trzustki, jajników, jąder.'
    }
]

export default featuresData;